import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { UstawieniaUzytkownikaService } from '@services/api/administracja/systems/ustawienia-uzytkownika.service';
import { Observable } from 'rxjs';

@Injectable()
export class AcceptLanguageHeaderInterceptor implements HttpInterceptor {
  private userLangPref = this.locale;

  constructor(
    @Inject(LOCALE_ID) private readonly locale: string,
    private readonly ustawieniaUzytkownikowService: UstawieniaUzytkownikaService,
  ) {
    this.ustawieniaUzytkownikowService.ustawieniaUzytkownika.subscribe((v) => {
      if (v) {
        this.userLangPref = v.jezykKod;
      }
    });
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const modifiedReq = request.clone({
      headers: request.headers.set('accept-language', this.userLangPref),
    });
    return next.handle(modifiedReq);
  }
}
